import { createAsyncThunk } from '@reduxjs/toolkit';
import { serializeError } from 'shared/utils/redux';
import { AIAvatarsModel } from 'api/dto/AIAvatar.dto';
import { aiAvatarServiceApi } from 'container/aiAvatarServiceApi';
import { aiSummaryServiceApi } from 'container/aiSummaryServiceApi';
import { AISummariesModel } from 'api/dto/AISummary.dto';
import { generateAvatarId } from 'shared/utils/api/generateAvatarId';

import { STORE_NAME } from './initialState';

export const fetchAIAvatar = createAsyncThunk<
  AIAvatarsModel,
  { pulseTemplateId: number; pulseId: number; departmentId?: number }
>(
  `${STORE_NAME}/fetchAIAvatar`,
  ({ pulseTemplateId, pulseId, departmentId }) => {
    const avatarId = generateAvatarId({
      pulseTemplateId,
      pulseId,
      departmentId,
      avatarNamespace: 'e0a96c80-9b4f-4e38-bf92-2388e4cf5b43',
    });
    return aiAvatarServiceApi.get({ avatarId });
  },
  { serializeError }
);

export const fetchPerspectiveAIAvatar = createAsyncThunk<
  AIAvatarsModel,
  { perspectiveAvatarId: string }
>(
  `${STORE_NAME}/fetchPerspectiveAIAvatar`,
  ({ perspectiveAvatarId: avatarId }) => aiAvatarServiceApi.get({ avatarId }),
  { serializeError }
);

export const fetchAISummary = createAsyncThunk<
  AISummariesModel,
  { pulseTemplateId: number; pulseId: number; departmentId?: number }
>(
  `${STORE_NAME}/fetchAISummary`,
  ({ pulseTemplateId, pulseId, departmentId }) =>
    aiSummaryServiceApi.get({
      pulseTemplateId,
      pulseId,
      departmentId,
      summaryNamespace: 'e0a96c80-9b4f-4e38-bf92-2388e4cf5b42',
    }),
  { serializeError }
);
